var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"embed-container",attrs:{"id":'module-video-' + _vm.dModule.id}},[_c('iframe',{attrs:{"width":"100%","src":_vm.embedSrc,"frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }